export { loginSuccess };

function loginSuccess(payload: unknown) {
  if (!isIntegrationTestOn()) {
    return;
  }

  const dialog = document.createElement('div');
  dialog.setAttribute('data-test', 'login_success_dialog');
  dialog.innerHTML = `<h1>Login successful</h1>
    <pre>${JSON.stringify(payload, null, '\t')}</pre>
    `;

  const style = document.createElement('style');
  style.innerHTML = `
        [data-test=login_success_dialog] {    width: 500px;
            position: absolute;
            left: 0;
            overflow: hidden;
        }
    `;
  document.head.appendChild(style);

  document.querySelector(`[data-test=oneAuth]`)?.parentElement?.appendChild(dialog);
}

export function isIntegrationTestOn() {
  return window?.location?.search.indexOf('integration') > -1;
}
